import * as types from "./mutation_types"

export default {
    [types.RESET](state){
        Object.assign(state,{
            isLoading: false,
            reply: {},
            isReplied:false,
            showMessage: false,
            message: "",
            isSuccess: false,
            currentItem: null,
            fileReply: null,
            messageReply:null,
            parentReply:null,
            pttReply:null,
            chunkerReply:[],

    
        })
    },
    [types.SET_FILE_REPLY](state,fileReply){
        Object.assign(state,{fileReply})
    },
    [types.SET_CHUNKER_REPLY](state,chunkerReply){
        Object.assign(state,{chunkerReply})
    },
    [types.SET_PTT_REPLY](state,pttReply){
        Object.assign(state,{pttReply})
    },
    [types.SET_MESSAGE_REPLY](state,messageReply){
        Object.assign(state,{messageReply})
    },
    [types.SET_PARENT_REPLY](state,parentReply){
        Object.assign(state,{parentReply})
    },
    [types.SET_TOGGLE_LOADING](state){
        Object.assign(state,{isLoading:!state.isLoading})
    },
    [types.SET_SHOW_LOADING](state){
        Object.assign(state,{isLoading:true})
    },
    [types.SET_HIDE_LOADING](state){
        Object.assign(state,{isLoading:false})
    },
    [types.SET_TOGGLE_MESSAGE](state){
        Object.assign(state,{showMessage:!state.showMessage})
    },
    [types.SET_SHOW_MESSAGE](state){
        Object.assign(state,{showMessage:true})
    },
    [types.SET_HIDE_MESSAGE](state){
        Object.assign(state,{showMessage:false})
    },
   
    [types.SET_IS_SUCCESS](state){
        Object.assign(state,{isSuccess:true})
    },
    [types.SET_IS_ERROR](state){
        Object.assign(state,{isSuccess:false})
    },
    [types.SET_MESSAGE](state,message){
        Object.assign(state,{message})
    },
    [types.SET_REPLY](state,reply){
        Object.assign(state,{reply})
    },
    [types.SET_IS_REPLIED](state){
        Object.assign(state,{isReplied:true})
    },
    [types.SET_NOT_REPLIED](state){
        Object.assign(state,{isReplied:false})
    },
    
    [types.SET_CURRENT_ITEM](state,currentItem){
        Object.assign(state,{currentItem})
    },
}